import {logEvent} from 'analytics';
import {gtmAnnouncementExperimentExposure, gtmAppTabView} from 'utils/gtm';
import type {Announcement} from './index';
import {pendingHumanizerEntry} from 'humanizerEntry';
import {getABVariant} from 'utils/abTest';

export const humanizerV2: Announcement = {
    id: 'humanizer-v2',
    // The saved grant survives login, workspace changes and other devices; pending
    // attribution covers the hand-off before the server has acknowledged it.
    audience: root => root.user.humanizerAvailable
        && !root.user.user?.humanizer_entry_page
        && !root.user.user?.humanizer_default_access
        && !pendingHumanizerEntry(),
    shouldShow: () => {
        const variant = getABVariant('humanizerAnnouncement');
        void logEvent(gtmAnnouncementExperimentExposure('humanizer-v2', variant));
        return variant === 'show';
    },
    copy: {
        eyebrow: 'announcement-humanizer-v2-eyebrow',
        title: 'announcement-humanizer-v2-title',
        subtitle: 'announcement-humanizer-v2-subtitle',
        features: [
            'announcement-humanizer-v2-feature-scan',
            'announcement-humanizer-v2-feature-modes',
            'announcement-humanizer-v2-feature-free',
        ],
        cta: 'announcement-humanizer-v2-cta',
    },
    image: {
        desktop: '/announcements/humanizer-v2.webp',
        mobile: '/announcements/humanizer-v2-mobile.webp',
    },
    // An empty Humanizer, not the scan adopted into it: adopting replaces whatever the
    // user has left in its panes.
    onCta: root => {
        root.layout.setWorkspace('humanizer');
        logEvent(gtmAppTabView({tab_name: 'humanizer', page_type: 'app_scan', entrypoint: 'announcement'}));
    },
};
